module.exports = __webpack_public_path__ + "static/img/bagutte.dc56a08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bagutte.jpg
// module id = tMWS
// module chunks = 1